<template>
    <x-data-table
        class="no-row-hover"
        :headers="headers"
        :items="formattedInvoices"
        hide-actions
    >
        <template v-slot:no-data>
            <p class="error-message text-xs-center">No invoices made</p>
        </template>

        <template v-slot:items="props">
            <td>
                {{ props.item.id }}
            </td>

            <td class="text-xs-right">
                {{ props.item.contract_value | currency(props.item.currency_code) }}
            </td>

            <td class="text-xs-right">
                {{ props.item.limit_of_liability | currency(props.item.currency_code) }}
            </td>

            <td class="text-xs-right">
                {{ props.item.indemnity | percent }}
            </td>

            <td>
                {{ props.item.inception_date | formatDate }}
            </td>

            <td>
                {{ props.item.expiry_date | formatDate }}
            </td>

            <td>
                <status-chip :status="props.item.status" small />
            </td>

            <td class="text-xs-right">
                <x-btn
                    @click="goToRisk(props.item.id)"
                    color="primary"
                    outline
                    small
                >
                    View
                </x-btn>
            </td>
        </template>
    </x-data-table>
</template>

<script>
    import StatusChip from '~/components/Shared/UIComponents/StatusChip';

    export default {
        name: 'InvoicesTable',
        components: {
            StatusChip
        },
        props: {
            invoices: {
                type: Array,
                default: []
            },
        },
        data() {
            return {
                headers: [
                    {
                        text: 'Invoice ID',
                        value: 'id'
                    },
                    {
                        text: 'Guaranteed value',
                        value: 'contract_value',
                        align: 'right'
                    },
                    {
                        text: 'Limit of liability',
                        value: 'limit_of_liability',
                        align: 'right'
                    },
                    {
                        text: 'Indemnity',
                        value: 'indemnity',
                        align: 'right'
                    },
                    {
                        text: 'Date of attachment',
                        value: 'inception_date'
                    },
                    {
                        text: 'Date of expiry',
                        value: 'expiry_date'
                    },
                    {
                        text: 'Status',
                        value: 'status'
                    },
                    {
                        // 'View invoice' column
                        sortable: false,
                        class: 'no-padding'
                    }
                ]
            }
        },
        computed: {
            formattedInvoices() {
                return this.invoices.map(invoice => {
                    const invoiceRisk = invoice.declaration || invoice;
                    const invoiceFirmOrder = invoice.firm_orders.find(firmOrder => ['reviewing', 'captive_reviewing'].includes(firmOrder.status));

                    return {
                        id: invoice.id,
                        contract_value: invoiceRisk.current_contract_value || invoiceRisk.contract_value,
                        limit_of_liability: invoiceRisk.limit_of_liability,
                        indemnity: invoiceRisk.indemnity,
                        inception_date: invoiceRisk.inception_date || invoiceFirmOrder?.inception_date || '',
                        expiry_date: invoiceRisk.expiry_date || invoiceFirmOrder?.expiry_date || '',
                        status: invoiceRisk.status,
                        currency_code: invoiceRisk.currency.code
                    }
                });
            },

        },
        methods: {
            goToRisk(riskId) {
                const pathUserType = ['insurer', 'captive_insurer'].includes(this.$root.user.company.company_type) ? 'insurer' : 'agent';
                this.$router.push({path: `/${pathUserType}/risk/${riskId}`});
            }
        }
    }
</script>
